import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlockName } from '../../shared/types/projectTypes';

interface PageState {
    activePage: string;
    activeBlock: BlockName | null;
    addedHashtag: string;
    cropMode: 'move' | 'crop' | 'resize';
    activeEditorMode: 'Visual' | 'Captions' | 'Review';
    activeSettingsSlider: string | null;
    pricingModal: boolean;
}

export const initialState: PageState = {
    activePage: '',
    activeBlock: null,
    addedHashtag: '',
    cropMode: 'move',
    activeEditorMode: 'Visual',
    activeSettingsSlider: null,
    pricingModal: false,
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setActivePage(state, action) {
            state.activePage = action.payload;
        },
        toggleActivePrompt: (state, action: PayloadAction<BlockName | null>) => {
            if (state.activeBlock === action.payload) {
                // state.activeBlock = null;
            } else {
                state.activeBlock = action.payload;
            }
        },
        setAddedHashtag(state, action) {
            state.addedHashtag = action.payload;
        },
        setCropMode(state, action) {
            state.cropMode = action.payload;
        },
        setActiveEditorMode(state, action) {
            state.activeEditorMode = action.payload;
        },
        setActiveSettingsSlider(state, action) {
            state.activeSettingsSlider = action.payload;
        },
        setPricingModal(state, action) {
            state.pricingModal = action.payload;
        },
    },
});

export const {
    setActivePage,
    toggleActivePrompt,
    setAddedHashtag,
    setCropMode,
    setActiveEditorMode,
    setActiveSettingsSlider,
    setPricingModal,
} = pageSlice.actions;

export default pageSlice.reducer;
